/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { FC, ReactNode } from "react";
import Popover from "@mui/material/Popover";
import { basicPopoverAnchorElSelector } from "../../../store/helpers/helperSelectors";
import { useSelector } from "react-redux";
import { useStoreDispatch } from "../../../store/hooks";
import { setBasicPopoverAnchorEl } from "../../../store/helpers/helperReducers";
import { Modal, ModalOwnerState, Paper } from "@mui/material";
import { SlotComponentProps } from "@mui/base";

interface IBasicPopoverProps {
  children?: ReactNode;
  popoverId?: string | undefined;
  handleClickToOpenPopover?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  slotProps?: {
    root?: SlotComponentProps<typeof Modal, {}, ModalOwnerState>;
    paper?: SlotComponentProps<typeof Paper, {}, {}>;
  };
}

const BasicPopover: FC<IBasicPopoverProps> = ({ children, popoverId = "basic-popover", slotProps, handleClickToOpenPopover }) => {
  const dispatch = useStoreDispatch();
  const basicPopoverAnchorEl = useSelector(basicPopoverAnchorElSelector);
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleClose = () => {
    dispatch(setBasicPopoverAnchorEl(null));
  };

  const open = Boolean(basicPopoverAnchorEl);
  // const popoverId = open ? `${id}-popover` : undefined;

  return (
    <Popover
      id={open ? popoverId : undefined}
      open={open}
      anchorEl={basicPopoverAnchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      slotProps={slotProps}
    >
      {children}
    </Popover>
  );
};

export default BasicPopover;
